import customAxios from "../utils/customAxios";

export const inquiryReferralCode = async (code) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await customAxios.post(
      "/api/admin/referrals/inq-code",
      { code },
      config
    );

    return res.data;
  } catch (err) {
    // console.log(err);
    // return [err];
  }
};